import React, { useEffect, useState } from "react";
import "./users.css";
import AdminSideBar from "../admin-page/AdminSideBar";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { RegisterUserApi } from "../../redux/apiCalls/authApiCall";
import swal from "sweetalert";
import { deleteUserProfileApi, getAllUserApi, updateUserApi } from "../../redux/apiCalls/profileApiCall";
import { authActions } from "../../redux/slices/authSlice";

function Users() {
  const { user, registerMessage } = useSelector((state) => state.auth);
  const { profiles, isProfileDeleted } = useSelector((state) => state.profile);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [addPop, setAddPop] = useState(false);
  const [updatePop, setUpdatePop] = useState(false);

  // Add POP fields
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [department, setDepartment] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const dispatch = useDispatch();

  // Add user form handler
  const addSubmitHandler = (e) => {
    e.preventDefault();
    if (userName.trim() === "") return toast.error("username is required");
    if (email.trim() === "") return toast.error("Email is required");
    if (password.trim() === "") return toast.error("Password is required");
    if (department === "") return toast.error("department is required");

    // Dispatch API to add user
    dispatch(RegisterUserApi({ userName, email, password, department, isAdmin }));
  };


  const openUpdatePopup = () => {
    if (selectedUsers.length !== 1)
      return toast.info("Select one user to update");
  
    const userToUpdate = profiles.find((u) => u._id === selectedUsers[0]);
    setUserName(userToUpdate.userName); // readonly
    setEmail(userToUpdate.email);
    setDepartment(userToUpdate.department);
    setIsAdmin(userToUpdate.isAdmin);
    setPassword(""); // empty by default
    setUpdatePop(true);
  };
  


  // ✅ Fix duplicate popup: useEffect watches registerMessage
  useEffect(() => {
    if (registerMessage) {
      swal({
        title: registerMessage,
        icon: "success",
      }).then(() => {
        setAddPop(false); // close modal
        dispatch(authActions.clearRegisterMessage()); // clear message to prevent duplicate popup
        dispatch(getAllUserApi()); // refresh users immediately
      });
    }
  }, [registerMessage, dispatch]);

  // Delete handler
  const deleteUserHandler = () => {
    if (selectedUsers.length === 0) return toast.info("Select at least one user");

    swal({
      title: "Are you sure?",
      text: `Delete ${selectedUsers.length} user(s)?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteUserProfileApi(selectedUsers));
      }
    });
  };

  // Fetch users initially
  useEffect(() => {
    dispatch(getAllUserApi());
  }, [dispatch, isProfileDeleted]);

  return (
    <main className="admin-page">
      <ToastContainer theme="colored" position="top-center" />
      <div className="admin-layout">
        <AdminSideBar />

        <section className="admin-main">
          {/* Header */}
          <header className="admin-main-header">
            <div className="users-header-sticky">
              <h2 className="admin-main-title">Users</h2>
              <p className="admin-main-subtitle">List of all users with their details.</p>
            </div>

            <div className="users-header-actions">
              <button onClick={() => setAddPop(true)} className="users-add-btn-small">
                + Add User
              </button>

              <div className="users-count-actions">
                <div className="users-count">Total Users: {profiles.length}</div>
                <div className="users-actions">
                <button onClick={openUpdatePopup} className="btn-action">Update User</button>
                  <button onClick={deleteUserHandler} className="btn-action">Delete User</button>
                  
                </div>
              </div>
            </div>
          </header>

          <div className="admin-main-body">
            <div className="users-card">
              <div className="users-table-wrapper">
                <table className="users-table">
                  <thead>
                    <tr>
                      <th><input type="checkbox" /></th>
                      <th>#</th>
                      <th>Profile</th>
                      <th>Username</th>
                      <th>Email</th>
                      <th>Department</th>
                      <th>Role</th>
                    </tr>
                  </thead>
                  <tbody>
                    {profiles.map((item, index) => (
                      <tr key={item._id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedUsers.includes(item._id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedUsers([...selectedUsers, item._id]);
                              } else {
                                setSelectedUsers(selectedUsers.filter((id) => id !== item._id));
                              }
                            }}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>
                          <div className="users-avatar">
                            <img src={item?.profilePicture?.url} alt="User profile" />
                          </div>
                        </td>
                        <td>{item?.userName}</td>
                        <td>{item?.email}</td>
                        <td>
                          <span className="users-badge users-badge-it">{item?.department}</span>
                        </td>
                        <td>{item?.isAdmin ? "admin" : "user"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Add User POP */}
          {addPop && (
            <div className="users-popup-overlay">
              <div className="users-popup">
                <h3 className="users-popup-title">Add New User</h3>

                <form onSubmit={addSubmitHandler} className="users-form">
                  <div className="users-form-group">
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="Enter username"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>

                  <div className="users-form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="users-form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="users-form-group">
                    <label>Department</label>
                    <select value={department} onChange={(e) => setDepartment(e.target.value)}>
                      <option value="">Select Department</option>
                      <option value="IT">IT</option>
                      <option value="HR">HR</option>
                      <option value="Finance">Finance</option>
                      <option value="Audit">Audit</option>
                      <option value="Communication">Communication</option>
                      <option value="Legal">Legal</option>
                    </select>
                  </div>

                  <div className="users-form-group users-checkbox">
                    <input
                      type="checkbox"
                      id="isAdmin"
                      checked={isAdmin}
                      onChange={(e) => setIsAdmin(e.target.checked)}
                    />
                    <label htmlFor="isAdmin">Admin User</label>
                  </div>

                  <div className="users-form-actions">
                    <button onClick={() => setAddPop(false)} type="button" className="btn-cancel">
                      Cancel
                    </button>
                    <button type="submit" className="btn-save">Save User</button>
                  </div>
                </form>
              </div>
            </div>
          )}


  {/* Update User POP */}
{updatePop && selectedUsers.length === 1 && (
  <div className="users-popup-overlay">
    <div className="users-popup">
      <h3 className="users-popup-title">Update User</h3>

      <form
  onSubmit={(e) => {
    e.preventDefault();
    const updatedUser = {
      _id: selectedUsers[0], // ✅ send the ID for URL
      email,
      password,
      department,
      isAdmin,
    };
    dispatch(updateUserApi(updatedUser));
    setUpdatePop(false);
  }}
  className="users-form"
>

        <div className="users-form-group">
          <label>Username</label>
          <input
            type="text"
            value={userName}
            disabled // ✅ make it read-only
          />
        </div>

        <div className="users-form-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="users-form-group">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="users-form-group">
          <label>Department</label>
          <select value={department} onChange={(e) => setDepartment(e.target.value)}>
            <option value="">Select Department</option>
            <option value="IT">IT</option>
            <option value="HR">HR</option>
            <option value="Finance">Finance</option>
            <option value="Audit">Audit</option>
            <option value="Communication">Communication</option>
            <option value="Legal">Legal</option>
          </select>
        </div>

        <div className="users-form-group users-checkbox">
          <input
            type="checkbox"
            id="isAdminUpdate"
            checked={isAdmin}
            onChange={(e) => setIsAdmin(e.target.checked)}
          />
          <label htmlFor="isAdminUpdate">Admin User</label>
        </div>

        <div className="users-form-actions">
          <button
            type="button"
            className="btn-cancel"
            onClick={() => setUpdatePop(false)}
          >
            Cancel
          </button>
          <button type="submit" className="btn-save">Update User</button>
        </div>
      </form>
    </div>
  </div>
)}


        </section>
      </div>
    </main>
  );
}

export default Users;
